// in addUploadFeature.js
/**
 * Convert a `File` object returned by the upload input into a base 64 string.
 * That's not the most optimized way to store images in production, but it's
 * enough to illustrate the idea of data provider decoration.
 */
import * as Constant from '../util/constant'

export const convertFileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    console.log('convertFileToBase64: file = ');
    console.log(file.rawFile);
    reader.readAsDataURL(file.rawFile);

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});

/**
 * For posts update only, convert uploaded image in base 64 and attach it to
 * the `picture` sent property, with `src` and `title` attributes.
 */
const uploadFileProvider = requestHandler => (type, resource, params) => {
    if ((type === 'CREATE' || type === 'UPDATE') && resource === 'driver') {
        console.log('Uploaded files:');
        console.log(params.data.photo);
        console.log(params.data.driving_license);
        console.log(params.data.id_card);

        if(params.data.photo == null && 
            params.data.driving_license == null && params.data.id_card == null){
            return requestHandler(type, resource, params);
        }

        var files = [];
        if(params.data.photo != null){
            params.data.photo.doc_type = Constant.UB_DOC_TYPE_PHOTO;
            files = [...files, params.data.photo];
        }


        if(params.data.driving_license != null){
            params.data.driving_license.doc_type = Constant.UB_DOC_TYPE_DRIVING_LICENSE;
            files = [...files, params.data.driving_license];
        }

        if(params.data.id_card != null){
            params.data.id_card.doc_type = Constant.UB_DOC_TYPE_ID_CARD;
            files = [...files, params.data.id_card];
        }

        delete params.data['photo'];
        delete params.data['driving_license'];
        delete params.data['id_card'];

        params.data.files = files;

        console.log('Files length = ' + params.data.files.length);
        const formerFiles = params.data.files.filter(p => !(p.rawFile instanceof File));
        const newFiles = params.data.files.filter(p => p.rawFile instanceof File);

        return Promise.all(newFiles.map(convertFileToBase64))
            .then(base64Files => base64Files.map((base64, index) => ({
                src: base64,
                title: `${newFiles[index].title}`,
                doc_type: `${newFiles[index].doc_type}`,
            })))
            .then(transformedNewFiles => requestHandler(type, resource, {
                ...params,
                data: {
                    ...params.data,
                    files: [...transformedNewFiles, ...formerFiles],
                },
            }));
        
    }

    if ((type === 'CREATE' || type === 'UPDATE') && resource === 'driver_company') {
        // console.log('Uploaded files:');
        // console.log(params.data.rib);
        // console.log(params.data.kbis);
        // console.log(params.data.rcp);
        // console.log(params.data.company_status);
        // console.log(params.data.manager_id_card_recto);
        // console.log(params.data.manager_id_card_verso);
        // console.log(params.data.manager_address_proof_recto);

        if(params.data.rib == null && 
            params.data.company_status == null && params.data.kbis == null && params.data.rcp == null
            && params.data.manager_id_card_recto == null && params.data.manager_id_card_verso == null && params.data.manager_address_proof_recto == null){
            return requestHandler(type, resource, params);
        }

        var files = [];
        if(params.data.rib != null){
            params.data.rib.doc_type = Constant.UB_DOC_TYPE_RIB;
            files = [...files, params.data.rib];
        }


        if(params.data.kbis != null){
            params.data.kbis.doc_type = Constant.UB_DOC_TYPE_KBIS;
            files = [...files, params.data.kbis];
        }

        if(params.data.rcp != null){
            params.data.rcp.doc_type = Constant.UB_DOC_TYPE_RCP;
            files = [...files, params.data.rcp];
        }

        if(params.data.company_status != null){
            params.data.company_status.doc_type = Constant.UB_DOC_TYPE_COMPANY_STATUS;
            files = [...files, params.data.company_status];
        }

        if(params.data.manager_id_card_recto != null){
            params.data.manager_id_card_recto.doc_type = Constant.UB_DOC_TYPE_ID_CARD_RECTO;
            files = [...files, params.data.manager_id_card_recto];
        }

        if(params.data.manager_id_card_verso != null){
            params.data.manager_id_card_verso.doc_type = Constant.UB_DOC_TYPE_ID_CARD_VERSO;
            files = [...files, params.data.manager_id_card_verso];
        }

        if(params.data.manager_address_proof_recto != null){
            params.data.manager_address_proof_recto.doc_type = Constant.UB_DOC_TYPE_ADDRESS_PROOF_RECTO;
            files = [...files, params.data.manager_address_proof_recto];
        }


        delete params.data['rib'];
        delete params.data['kbis'];
        delete params.data['rcp'];
        delete params.data['company_status'];
        delete params.data['manager_id_card_recto'];
        delete params.data['manager_id_card_verso'];
        delete params.data['manager_address_proof_recto'];

        params.data.files = files;

        console.log('Files length = ' + params.data.files.length);
        const formerFiles = params.data.files.filter(p => !(p.rawFile instanceof File));
        const newFiles = params.data.files.filter(p => p.rawFile instanceof File);

        return Promise.all(newFiles.map(convertFileToBase64))
            .then(base64Files => base64Files.map((base64, index) => ({
                src: base64,
                title: `${newFiles[index].title}`,
                doc_type: `${newFiles[index].doc_type}`,
            })))
            .then(transformedNewFiles => requestHandler(type, resource, {
                ...params,
                data: {
                    ...params.data,
                    files: [...transformedNewFiles, ...formerFiles],
                },
            }));
        
    }

    if ((type === 'CREATE' || type === 'UPDATE') && resource === 'customer_manager') {
        console.log('Uploaded files:');
        console.log(params.data.id_card_recto);
        console.log(params.data.id_card_verso);
        console.log(params.data.address_proof_recto);
        
        var files = [];
        if(params.data.id_card_recto != null){
            params.data.id_card_recto.doc_type = Constant.UB_DOC_TYPE_ID_CARD_RECTO;
            files = [...files, params.data.id_card_recto];
        }

        if(params.data.id_card_verso != null){
            params.data.id_card_verso.doc_type = Constant.UB_DOC_TYPE_ID_CARD_VERSO;
            files = [...files, params.data.id_card_verso];
        }

        if(params.data.address_proof_recto != null){
            params.data.address_proof_recto.doc_type = Constant.UB_DOC_TYPE_ADDRESS_PROOF_RECTO;
            files = [...files, params.data.address_proof_recto];
        }

        delete params.data['id_card_recto'];
        delete params.data['id_card_verso'];
        delete params.data['address_proof_recto'];

        params.data.files = files;

        console.log('Files length = ' + params.data.files.length);
        const formerFiles = params.data.files.filter(p => !(p.rawFile instanceof File));
        const newFiles = params.data.files.filter(p => p.rawFile instanceof File);

        return Promise.all(newFiles.map(convertFileToBase64))
            .then(base64Files => base64Files.map((base64, index) => ({
                src: base64,
                title: `${newFiles[index].title}`,
                doc_type: `${newFiles[index].doc_type}`,
            })))
            .then(transformedNewFiles => requestHandler(type, resource, {
                ...params,
                data: {
                    ...params.data,
                    files: [...transformedNewFiles, ...formerFiles],
                },
            }));
        
    }


    if ((type === 'CREATE' || type === 'UPDATE') && resource === 'vehicle') {
        console.log('Uploaded files:');
        console.log(params.data.front_image);
        console.log(params.data.rear_image);
        console.log(params.data.gray_card_recto);
        console.log(params.data.gray_card_verso);

        if(params.data.front_image == null && 
            params.data.rear_image == null && 
            params.data.gray_card_recto == null && 
            params.data.gray_card_verso == null){
            return requestHandler(type, resource, params);
        }

        var files = [];
        if(params.data.front_image != null){
            params.data.front_image.doc_type = Constant.UB_DOC_TYPE_VEHICLE_FRONT;
            files = [...files, params.data.front_image];
        }

        if(params.data.rear_image != null){
            params.data.rear_image.doc_type = Constant.UB_DOC_TYPE_VEHICLE_REAR;
            files = [...files, params.data.rear_image];
        }

        if(params.data.gray_card_recto != null){
            params.data.gray_card_recto.doc_type = Constant.UB_DOC_TYPE_VEHICLE_GRAY_CARD_RECTO;
            files = [...files, params.data.gray_card_recto];
        }

        if(params.data.gray_card_verso != null){
            params.data.gray_card_verso.doc_type = Constant.UB_DOC_TYPE_VEHICLE_GRAY_CARD_VERSO;
            files = [...files, params.data.gray_card_verso];
        }

        delete params.data['front_image'];
        delete params.data['rear_image'];
        delete params.data['gray_card_recto'];
        delete params.data['gray_card_verso'];

        params.data.files = files;

        console.log('Files length = ' + params.data.files.length);
        const formerFiles = params.data.files.filter(p => !(p.rawFile instanceof File));
        const newFiles = params.data.files.filter(p => p.rawFile instanceof File);

        return Promise.all(newFiles.map(convertFileToBase64))
            .then(base64Files => base64Files.map((base64, index) => ({
                src: base64,
                title: `${newFiles[index].title}`,
                doc_type: `${newFiles[index].doc_type}`,
            })))
            .then(transformedNewFiles => requestHandler(type, resource, {
                ...params,
                data: {
                    ...params.data,
                    files: [...transformedNewFiles, ...formerFiles],
                },
            }));
        
    }

    if ((type === 'CREATE' || type === 'UPDATE') && resource === 'vehicle_type') {
        console.log('Uploaded files:');
        console.log(params.data.map_icon);
        console.log(params.data.select_icon);

        if(params.data.map_icon == null && params.data.select_icon == null){
            return requestHandler(type, resource, params);
        }

        var files = [];
        if(params.data.map_icon != null){
            params.data.map_icon.doc_type = Constant.UB_DOC_TYPE_VEHICLE_TYPE_MAP;
            files = [...files, params.data.map_icon];
        }

        if(params.data.select_icon != null){
            params.data.select_icon.doc_type = Constant.UB_DOC_TYPE_VEHICLE_TYPE_SELECT;
            files = [...files, params.data.select_icon];
        }

        delete params.data['map_icon'];
        delete params.data['select_icon'];

        params.data.files = files;

        console.log('Files length = ' + params.data.files.length);
        const formerFiles = params.data.files.filter(p => !(p.rawFile instanceof File));
        const newFiles = params.data.files.filter(p => p.rawFile instanceof File);

        return Promise.all(newFiles.map(convertFileToBase64))
            .then(base64Files => base64Files.map((base64, index) => ({
                src: base64,
                title: `${newFiles[index].title}`,
                doc_type: `${newFiles[index].doc_type}`,
            })))
            .then(transformedNewFiles => requestHandler(type, resource, {
                ...params,
                data: {
                    ...params.data,
                    files: [...transformedNewFiles, ...formerFiles],
                },
            }));
        
    }

    if ((type === 'UPDATE') && resource === 'profile_photo') {
        console.log('Uploaded files:');
        console.log(params.data.binary_photo);
        
        if(params.data.binary_photo == null){
            return requestHandler(type, resource, params);
        }

        var files = [];
        if(params.data.binary_photo != null){
            files = [...files, params.data.binary_photo];
        }

        delete params.data['binary_photo'];
        
        params.data.files = files;

        console.log('Files length = ' + params.data.files.length);
        const formerFiles = params.data.files.filter(p => !(p.rawFile instanceof File));
        const newFiles = params.data.files.filter(p => p.rawFile instanceof File);

        return Promise.all(newFiles.map(convertFileToBase64))
            .then(base64Files => base64Files.map((base64, index) => ({
                src: base64,
                title: `${newFiles[index].title}`,
                
            })))
            .then(transformedNewFiles => requestHandler(type, resource, {
                ...params,
                data: {
                    ...params.data,
                    files: [...transformedNewFiles, ...formerFiles],
                },
            }));
    }


    if ((type === 'UPDATE') && resource === 'product') {
        console.log('Uploaded files:');
        console.log(params.data.photo);
        
        if(params.data.photo == null){
            return requestHandler(type, resource, params);
        }

        var files = [];
        if(params.data.photo != null){
            params.data.photo.doc_type = Constant.UB_DOC_TYPE_PHOTO;    
            files = [...files, params.data.photo];
        }

        delete params.data['photo'];
        
        params.data.files = files;
        

        console.log('Files length = ' + params.data.files.length);
        const formerFiles = params.data.files.filter(p => !(p.rawFile instanceof File));
        const newFiles = params.data.files.filter(p => p.rawFile instanceof File);

        return Promise.all(newFiles.map(convertFileToBase64))
            .then(base64Files => base64Files.map((base64, index) => ({
                src: base64,
                title: `${newFiles[index].title}`,
                doc_type: `${newFiles[index].doc_type}`,
                
            })))
            .then(transformedNewFiles => requestHandler(type, resource, {
                ...params,
                data: {
                    ...params.data,
                    files: [...transformedNewFiles, ...formerFiles],
                },
            }));
    }


    if ((type === 'CREATE' || type === 'UPDATE') && resource === 'doc') {
        // notice that following condition can be true only when `<ImageInput source="pictures" />` component has parameter `multiple={true}`
        // if parameter `multiple` is false, then data.pictures is not an array, but single object
        console.log('Uploaded files:');
        console.log(params.data.files);

        if(params.data.files == null){
            return requestHandler(type, resource, params);
        }

        if (params.data.files && params.data.files.length) {
            // only freshly dropped pictures are instance of File
            console.log('Files length = ' + params.data.files.length);
            const formerFiles = params.data.files.filter(p => !(p.rawFile instanceof File));
            const newFiles = params.data.files.filter(p => p.rawFile instanceof File);

            return Promise.all(newFiles.map(convertFileToBase64))
                .then(base64Files => base64Files.map((base64, index) => ({
                    src: base64,
                    title: `${newFiles[index].title}`,
                })))
                .then(transformedNewFiles => requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        files: [...transformedNewFiles, ...formerFiles],
                    },
                }));
        }
        else{
            var formerFile = null;
            if(!(params.data.files.rawFile instanceof File))
                formerFile = params.data.files;

            var formerFiles = [];
            if(formerFile != null)
                formerFiles = [formerFile];
            
            var newFile = null;
            if(params.data.files.rawFile instanceof File)
                newFile = params.data.files;
            
            var newFiles = [];
            if(newFile != null)
                newFiles = [newFile];

            return Promise.all(newFiles.map(convertFileToBase64))
                .then(base64Files => base64Files.map((base64, index) => ({
                    src: base64,
                    title: `${newFiles[index].title}`,
                })))
                .then(transformedNewFiles => requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        files: [...transformedNewFiles, ...formerFiles],
                    },
                }));
        }
    }
    // for other request types and resources, fall back to the default request handler
    return requestHandler(type, resource, params);
};

export default uploadFileProvider;